import { Directive, Input } from '@angular/core';
import { PerformancePieComponent } from '../components/performance-pie/performance-pie.component';
import { ManagementMetricsEntry } from '../types/management-metrics-result.type';
import { ProcessOverview } from '../types/process-overview.type';

@Directive({
  selector: 'shared-performance-pie',
  standalone: false,
})
export class PieSourceMetricsDirective {
  @Input() set sourceMetrics(value: ProcessOverview | ManagementMetricsEntry) {
    if (value == null) {
      this.host.arcs = [0, 0, 0, 0];
      return;
    }
    const processOverview = value as ProcessOverview;
    if (processOverview.completedItemsCount != null && processOverview.businessExceptionItemsCount != null && processOverview.systemExceptionItemsCount != null) {
      this.host.arcs = this.getPieDataFromProcessOverview(processOverview);
      return;
    }

    const managementMetrics = value as ManagementMetricsEntry;
    if (managementMetrics.tasksCompleted != null && managementMetrics.tasksSystemException != null && managementMetrics.tasksBusinessException != null && managementMetrics.tasksTotal != null) {
      this.host.arcs = this.getPieDataFromManagementMetrics(managementMetrics);
      return;
    }
  }

  constructor(private host: PerformancePieComponent) {}

  getPieDataFromProcessOverview(processOverview: ProcessOverview): number[] {
    if (processOverview == null) {
      return [0, 0, 0, 0];
    }

    const total = processOverview.completedItemsCount + processOverview.businessExceptionItemsCount + processOverview.systemExceptionItemsCount;
    const x = processOverview.completedItemsCount / total;
    const y = processOverview.businessExceptionItemsCount / total;
    const z = processOverview.systemExceptionItemsCount / total;

    return [x, y, z, 1 - x - y - z];
  }

  getPieDataFromManagementMetrics(metrics: ManagementMetricsEntry): number[] {
    if (metrics?.tasksTotal == null || metrics?.tasksTotal === 0) {
      return [0, 0, 0, 0];
    }

    const x = metrics.tasksCompleted / metrics.tasksTotal;
    const y = metrics.tasksBusinessException / metrics.tasksTotal;
    const z = metrics.tasksSystemException / metrics.tasksTotal;
    const w = 0;

    const total = x + y + z + w;
    if (total > 1) {
      return [x / total, y / total, z / total, w / total];
    }
    return [x, y, z, 1 - x - y - z];
  }
}
